import React from "react"
import { Input, Select, Button } from "antd"
import { SearchOutlined, PlusOutlined } from "@ant-design/icons"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Campaigns.css"

const { Option } = Select

const CampaignFilters = ({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  typeFilter,
  onTypeFilterChange,
  onCreateCampaign,
  readOnly = false,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.campaignsPage

  return (
    <div className="campaign-filters-container">
      <Input
        placeholder={t?.search_campaigns || "Search campaigns..."}
        prefix={<SearchOutlined className="campaign-search-icon" />}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        className="campaign-search-input"
      />

      <div className="campaign-filters-right">
        <Select
          value={statusFilter}
          onChange={onStatusFilterChange}
          className="campaign-filter-select campaign-filter-select-wrapper"
          size="large"
        >
          <Option value="All Status">
            {t?.filters?.all_status || "All Status"}
          </Option>
          <Option value="Scheduled">
            {t?.filters?.status?.scheduled || "Scheduled"}
          </Option>
          <Option value="Draft">{t?.filters?.status?.draft || "Draft"}</Option>
          <Option value="Saved">{t?.filters?.status?.saved || "Saved"}</Option>
          {/* <Option value="Send Immediately">{t?.filters?.status?.send_immediately || "Send Immediately"}</Option> */}
          <Option value="Queue">{t?.filters?.status?.queue || "Queue"}</Option>
          <Option value="Completed">
            {t?.filters?.status?.completed || "Completed"}
          </Option>
          {/* <Option value="Canceled">{t?.filters?.status?.canceled || "Canceled"}</Option>
          <Option value="Failed">{t?.filters?.status?.failed || "Failed"}</Option> */}
        </Select>

        <Select
          value={typeFilter}
          onChange={onTypeFilterChange}
          className="campaign-filter-select campaign-filter-select-wrapper"
          size="large"
        >
          <Option value="All Types">
            {t?.filters?.all_types || "All Types"}
          </Option>
          <Option value="Promotional">
            {t?.filters?.types?.promotional || "Promotional"}
          </Option>
          <Option value="Seasonal">
            {t?.filters?.types?.seasonal || "Seasonal"}
          </Option>
          <Option value="Welcome">
            {t?.filters?.types?.welcome || "Welcome"}
          </Option>
          <Option value="Updates">
            {t?.filters?.types?.updates || "Updates"}
          </Option>
        </Select>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateCampaign}
          className="campaign-create-button"
          disabled={readOnly}
        >
          {t?.create_campaign || "Create Campaign"}
        </Button>
      </div>
    </div>
  )
}

export default CampaignFilters
